
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message, Loading } from "element-ui";
    import {imageUrl} from '@/utils/common'

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            org_id: '',
            bond_type: '',
            group: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        openBase64File() {
            // 假设你有一个Base64编码的文件字符串
            const base64File = this.file.url;

            // 将Base64文件字符串转换为Blob对象
            const byteCharacters = atob(base64File.split(",")[1]);
            const byteArrays = [];
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays.push(byteCharacters.charCodeAt(i));
            }
            const byteArray = new Uint8Array(byteArrays);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            // 创建一个URL来表示Blob对象
            const fileUrl = URL.createObjectURL(blob);
            // return fileUrl

            // 使用浏览器打开URL
            window.open(fileUrl, '_blank');
        }

        // 上传
        token = store.state.user.token
        fileArray: any = {}
        fileUrl: any = ''
        getData(data: any) {
            this.fileArray = data
            this.ruleForm.templte = data.filecode;
            // this.getFile(this.ruleForm.templte);
            this.ruleForm.templte_name = data.name
            this.fileUrl = imageUrl + data.filecode
        }

        // 新建
        addDialog = false
        btnloading = false
        ruleForm: any = {
            name: '',
            org_id: '',
            bond_type: '',
            templte: '',
            group: '',
        }

        save() {
            if(!this.ruleForm.name) {
                this.$message.warning('请输入名称')
                return
            }
            if(!this.ruleForm.org_id) {
                this.$message.warning('请选择机构')
                return
            }
            if(!this.ruleForm.bond_type) {
                this.$message.warning('请选择产品')
                return
            }
            if(!this.ruleForm.templte) {
                this.$message.warning('请上传文件')
                return
            }
            if(!this.ruleForm.group) {
                this.$message.warning('请选择文件分类')
                return
            }

            this.ruleForm.fileurl = imageUrl + this.ruleForm.templte
            this.fileUrl = imageUrl + this.ruleForm.templte

            this.btnloading = true;
            api.post(this.ruleForm.id ? 'A8003' : 'A8002', this.ruleForm).then(res => {
                this.$message.success('操作成功')
                this.addDialog = false
                this.searchTable()
            }).finally(() => {
                this.btnloading = false;
            })

        }
        cancle() {
            this.addDialog = false;
        }

        add() {
            this.ruleForm = {
                name: '',
                org_id: '',
                bond_type: '',
                templte: '',
                group: '',
            }
            this.file = {}
            this.addDialog = true
        }
        edit(row: any) {
            this.ruleForm = {
                id: row.id,
                name: row.name,
                org_id: row.org_id,
                bond_type: row.bond_type,
                templte: row.templte,
                templte_name: row.templte_name,
                group: row.group,
                fileurl: row.fileurl
            }
            this.fileUrl = imageUrl + row.templte
            this.file = {}
            this.addDialog = true
            // this.getFile(row.templte)
        }
        file: any = {}
        getFile(templte: any) {
            api.get('A8007&token=' + this.token + '&path=' + templte, this.token).then(res => {
                this.file = {
                    url: 'data:text/plain;base64,' + res.data,
                    name: res.name
                }
            })
        }

        // 查看
        toDetail(id: any) {

        }
        //日志
        logDialog = false
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        logTable = []
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A8004', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.total
                this.logDialog = true
            })

        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A8001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
            // 调用字典接口，可能会添加新机构
            api.getDics().then((res) => {
                store.dispatch("system/addConfig", res);
                this.config = store.state.system.config
            });
        }
    }
